enum EPaymentForms {
  'MONTHLY' = 'monthly',
  'QUARTERLY' = 'quarterly',
  'SEMIANNUALLY' = 'semiannually',
  'ANNUALLY' = 'annually',
}

export default EPaymentForms;
